
import { Vue, Component, Prop } from 'vue-property-decorator';
import { UploadDocument, DocumentTypeLabels } from '@/features/shipment/types/documentType';
import { getFileIcon, getFileExtension } from '@/features/shipment/helpers/documentValidation';
import { USMCA_VIRTUAL_DOC_ID } from '@/features/shipment/components/commercialInvoice/etd-constants';

@Component
export default class DocumentRow extends Vue {
  @Prop({ type: Object, required: true }) readonly document!: UploadDocument;

  @Prop({ type: Boolean, default: false }) readonly showError!: boolean;

  @Prop({ type: Boolean, default: false }) readonly isUploadInProgress!: boolean;

  @Prop({ type: Boolean, default: false }) readonly isSavedToLibrary!: boolean;

  get fileIcon(): string {
    return getFileIcon(this.document.originalFileName);
  }

  get isPdf(): boolean {
    return getFileExtension(this.document.originalFileName) === 'pdf';
  }

  get isProcessing(): boolean {
    return this.document.status === 'Processing';
  }

  get isTempUpload(): boolean {
    return this.isUploadInProgress && this.document.documentId.startsWith('temp-');
  }

  get isClean(): boolean {
    return this.document.status === 'Clean';
  }

  get isFailed(): boolean {
    return this.document.status === 'Failed';
  }

  get isUsmcaVirtual(): boolean {
    return this.document.documentId === USMCA_VIRTUAL_DOC_ID;
  }

  // eslint-disable-next-line class-methods-use-this
  get documentTypeOptions(): Array<{ text: string; value: string }> {
    return Object.entries(DocumentTypeLabels).map(([value, text]) => ({
      text,
      value,
    }));
  }

  private onTypeChanged(value: string): void {
    this.$emit('type-changed', {
      documentId: this.document.documentId,
      documentType: value,
    });
  }
}
